import React, { useState } from 'react';
import axios from 'axios';
import { API_URL, getAuthHeaders } from '../../Constant';
import messages from '../../assets/Messages.json';
import { ToastContainer, toast } from "react-toastify";
import { GlobalLoading, showLoading } from "react-global-loading";
import { validateFileForUpload } from '../../utils/fileValidation';

function Index() {

    const [file, setFile] = useState(null);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');


    


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setError('');
        setSuccessMessage('');
        if (!selectedFile) return;

        const fileName = selectedFile.name || '';
        const extensionParts = fileName.split('.');
        if (extensionParts.length > 2) {
            toast.error('Double extension file is not allowed.', messages.COLOR_RED);
            setFile(null);
            e.target.value = '';
            return;
        }

        const result = validateFileForUpload(selectedFile, ['.zip'], {
            maxSize: 100 * 1024 * 1024,
            sizeErrorMsg: 'File size should be 100 MB or less.',
        });
        if (!result.valid) {
            toast.error(result.error, messages.COLOR_RED);
            setFile(null);
            e.target.value = '';
            return;
        }
        setFile(selectedFile);
    };

    const handleUpload = async () => {
        if (!file) {
            toast.error(messages.SELECT_FILE, messages.COLOR_RED);
            return;
        }

        showLoading(true);
        const formData = new FormData();
        formData.append('file', file);
        const config = getAuthHeaders();

        try {
            const response = await axios.post(`${API_URL}api/price/uploadZipData`, formData, {
                ...config,
                headers: {
                    ...config.headers,
                    'Content-Type': 'multipart/form-data',
                },
            });
            const data = response.data;

            if (!data?.status) {
                throw { data };
            }

            const fileInput = document.getElementById('fileInput');
            if (fileInput) {
                fileInput.value = '';
            }
            setFile(null);
            toast.success(messages.FILE_UPLOADED, messages.COLOR_RED);
        } catch (error) {
            const apiErrorCode = error?.response?.data?.code || error?.data?.code;
            const apiErrorMessage = error?.response?.data?.message || error?.data?.message;
            const defaultErrorMessage = messages.SOMETHING_WENT_WRONG || 'Upload failed. Please try again.';

            const toastMessage = apiErrorCode === 'INVALID_ZIP_CONTENT'
                ? apiErrorMessage
                : (apiErrorMessage || defaultErrorMessage);

            toast.error(toastMessage, messages.COLOR_RED);
            console.error('Error uploading file:', error);
        } finally {
            showLoading(false);
        }
    };


    const storedLanguage = localStorage.getItem('language');

    return (
        <>
            {/* Page Content Open   */}
            <ToastContainer />
            <GlobalLoading />
            <div className="container-fluid py-3 px-3">
                <div className="card mb-3">
                    <div className="card-body">
                        <h4 className="page_heading">Upload Data</h4>
                        
                        <div className="row align-items-center">            
                            <div className="col-xl-4 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                <label>Upload a file</label>
                                <input type="file" className="form-control" onChange={handleFileChange}  id="fileInput"/>
                               
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                <label className="w-100">&nbsp;</label>
                                <button type="button" className="btn btn_orange" onClick={handleUpload} >Submit</button>
                            </div>
                            {error && <p className="text-danger">{error}</p>}
                        </div> 
                    </div>
                </div>
            </div>

        </>
    )
}

export default Index